<div class="modal-body">
  @switch (this.type) {
    @case ('youtubeCard') {
      <div
        [class]="'message-card-youtube ' + this.youtubeCard.data.cssClass"
        >
        <iframe
          [src]="('https://www.youtube-nocookie.com/embed/' + this.youtubeCard.data.id) | safe"
          title="YouTube video player"
          frameborder="0"
          allow="display-capture;camera;microphone;geolocation; fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    }
    @case ('buttonsCard') {
      <div
        [class]="'message-card-buttons ' + this.buttonCard.data.cssClass"
        >
        @if (this.buttonCard.data) {
          <app-button-card
            [isLast]="true"
            [buttons]="this.buttonCard.data.buttons"
          ></app-button-card>
        }
      </div>
    }
    @case ('htmlCard') {
      <div
        [class]="'message-card-html ' + this.htmlCard.data.cssClass"
        >
        <div [innerHTML]="this.htmlCard.data.html"></div>
      </div>
    }
    @case ('iframeCard') {
      <div
        [class]="'message-card-iframe ' + this.iframeCard.data.cssClass"
        >
        <iframe
          [title]="this.iframeCard.data.url"
          width="auto"
          [src]="this.iframeCard.data.url | safe"
          style="border: 1px solid black;"
          allow="display-capture;camera;microphone;geolocation; fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
    }
    @case ('imageCard') {
      <div
        [class]="'message-card-image ' + this.imageCard.data.cssClass"
        >
        <img
          [src]="this.imageCard.data.src| safe"
          [alt]="this.imageCard.data.altText"
          >
      </div>
    }
    @case ('vimeoCard') {
      <div
        [class]="'message-card-vimeo ' + this.vimeoCard.data.cssClass"
        >
        <iframe
          title="Vimeo video player"
        [src]="('https://player.vimeo.com/video/' + this.vimeoCard.data.id + '?h=' + this.vimeoCard.data.hash) | safe"
        frameborder="0"
      ></iframe>
    </div>
}

    @default {
<p
     
      i18n="@@cardtypeUnsopported"
    >
      Dieser Card Type wird aktuell nicht unterstützt.
    </p>
}
  }

</div>